// @refresh reset
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';
import AuthLayout from 'layout/Auth';
import ErrorBoundary from 'components/ErrorBoundary';

const Login = Loadable(lazy(() => import('views/auth/Login')));
const ForgotPassword = Loadable(lazy(() => import('views/auth/ForgotPassword')));
const ResetPassword = Loadable(lazy(() => import('views/auth/ResetPassword')));

// ==============================|| AUTH ROUTES ||============================== //

const AuthRoutes = {
  path: '/',
  element: <AuthLayout />,
  errorElement: <ErrorBoundary />,
  children: [
    { path: 'login', element: <Login /> },
    { path: 'forgot-password', element: <ForgotPassword /> },
    { path: 'reset-password', element: <ResetPassword /> },
    { path: '*', element: <Navigate to="/login" replace /> }
  ]
};

export default AuthRoutes;
